<template>
  <div>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      sortBy="Order"
      :exporters="$exporters"
      @itemsChanged="$emit('categories-changed', $event)"
      @error="error = $event"
    ></pbas-data-table>

    <category-edit
      :allItems="items"
      :category="editCategory"
      @cancel="editCategory = null"
      @update:category="
        editCategory = null;
        $refs.table.getDataAsync();
      "
      @reload-items="$emit('reload-items')"
    ></category-edit>

    <error-handler :error="error" />
  </div>
</template>

<script>
import CoverageCategoriesHeaders from "../../headers/CoverageCategories";
import { ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import CategoryEdit from "./CategoryEdit";
import ErrorHandler from "../../components/ErrorHandler";

export default {
  components: { CategoryEdit, ErrorHandler },
  props: {
    items: Array,
  },
  data: function() {
    return {
      editCategory: null,
      provider: undefined,
      headers: CoverageCategoriesHeaders,
      error: null,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.edit(item),
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => this.remove(item),
        },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.edit({
              Order: 0,
              PlanId: this.selectedPlan.Id,
              CoverageTileItemCoverageTiles: [],
            });
          },
        },
      ],
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.remove",
          handler: (items) => {
            items.forEach((i) => this.remove(i));
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  watch: {
    items: {
      handler(v) {
        // this.$refs.table.getDataAsync();
      },
    },
  },
  mounted() {
    this.provider = new ODataProvider(
      this.$axiosHttp,
      this.settings.APIURL +
        "cms/odata/plans/" +
        this.selectedPlan.Id +
        "/CoverageTiles",
      this.headers
    );
  },
  methods: {
    ...mapActions("downloadCenter", ["deleteCoverageTile"]),
    reload() {
      this.$refs.table.getDataAsync();
    },
    edit(item) {
      this.editCategory = item;
    },
    async remove(item) {
      try {
        await this.deleteCoverageTile(item);
        this.$refs.table.getDataAsync();
      } catch (e) {
        this.error = e;
      }
    },
  },
};
</script>
